var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticlesActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8A76F7D2-E96A-4BD5-A5A8-145229477C4F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resource-Library",
    transform: "translate(-29.000000, -330.000000)",
    fill: "#F88801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Nav",
    transform: "translate(0.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "resource-active",
    transform: "translate(29.000000, 241.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.05940067,6.06060606e-05 L3.05771717,6.06060606e-05 C2.86855892,6.06060606e-05 2.69064646,0.0737979798 2.55630303,0.207804714 C2.42047811,0.343292929 2.3456633,0.52369697 2.3456633,0.715750842 L2.3456633,11.4474007 C2.3456633,11.840936 2.66707744,12.1619461 3.06222896,12.1628889 C4.72808754,12.166862 7.51906397,12.5140673 9.44445118,14.5289495 L9.44445118,3.29797306 C9.44445118,3.16457239 9.4103771,3.03925253 9.34606734,2.93554882 C7.76579798,0.390632997 4.7290303,0.00396632997 3.05940067,6.06060606e-05",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6543434,11.4474074 L17.6543434,0.715690236 C17.6543434,0.523636364 17.5795286,0.343232323 17.4437037,0.207744108 C17.3093603,0.0737373737 17.1313131,0 16.9423569,0 L16.9406061,0 C15.2710438,0.00397306397 12.2342761,0.390639731 10.6539394,2.93555556 C10.5896296,3.03925926 10.5556229,3.16457912 10.5556229,3.2979798 L10.5556229,14.5288889 C12.4810101,12.5140067 15.2719865,12.1668013 16.9378451,12.1628283 C17.3329293,12.1618182 17.6543434,11.8408754 17.6543434,11.4474074",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2843771,2.47493603 L18.7654545,2.47493603 L18.7654545,11.4473939 C18.7654545,12.4521751 17.9468013,13.2715017 16.9404714,13.2739933 C15.5274747,13.2773603 13.1976431,13.5537239 11.5476094,15.1153401 C14.4013468,14.4166195 17.409697,14.8708283 19.1241751,15.2615354 C19.3382492,15.3102896 19.5594613,15.2599192 19.7309764,15.1232189 C19.9018855,14.9868552 19.9999327,14.7830168 19.9999327,14.564229 L19.9999327,3.19049158 C19.9999327,2.79594613 19.6789226,2.47493603 19.2843771,2.47493603",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23447811,11.4474074 L1.23447811,2.47494949 L0.715555556,2.47494949 C0.321077441,2.47494949 0,2.7959596 0,3.19050505 L0,14.5640404 C0,14.7828956 0.098047138,14.9866667 0.268956229,15.1230303 C0.4403367,15.2596633 0.661346801,15.3102357 0.875757576,15.2613468 C2.59023569,14.8705724 5.5986532,14.416431 8.45225589,15.1151515 C6.80228956,13.5535354 4.47245791,13.2773064 3.05946128,13.2739394 C2.05319865,13.2715152 1.23447811,12.4521886 1.23447811,11.4474074",
    id: "Fill-8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticlesActive);
export default __webpack_public_path__ + "static/media/articles-active.841fe849.svg";
export { ForwardRef as ReactComponent };